module.exports = __webpack_public_path__ + "static/media/cocoyocimg.bad88d57.jpg";